<template>
  <div class="login-container">
    <img class="login-bg" src="@/assets/login/bg.png" />
    <div class="login-logo">
      <!-- <img class="login-logo-img" src="@/assets/login/logo.png" /> -->
      <span>药事服务</span>
    </div>
    <div v-if="!isScanCode" class="login-code-box" v-loading="loading">
      <div class="login-code-box-title">
        <!-- <img class="login-code-box-title-img" src="@/assets/login/logo.png" /> -->
        <span>欢迎登录</span>
      </div>
      <img v-if="!isExpired" class="login-code-img" :src="codeUrl" />
      <div v-if="isExpired" class="login-code-expired">
        <img class="login-code-expired-img" :src="codeUrl" />
        <div class="login-code-expired-text">已失效</div>
        <div class="login-code-expired-code" @click="fetchData">刷新二维码</div>
      </div>
      <div class="login-code-text">微信扫一扫登录</div>
      <!-- <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 10px;
        "
      >
        <el-button type="primary" size="mini" @click="handleLoginTest(1)"
          >连锁总部</el-button
        >
        <el-button type="primary" size="mini" @click="handleLoginTest(0)"
          >连锁门店</el-button
        >
      </div> -->
    </div>
    <div v-if="isScanCode" class="login-info-box" v-loading="loginLoading">
      <div class="login-info-box-title">
        <!-- <img class="login-info-box-title-img" src="@/assets/login/logo.png" /> -->
        <span>欢迎登录</span>
      </div>
      <!-- <img class="login-info-img" :src="icon" /> -->
      <div class="login-info-text-box">
        <div class="login-info-text">
          <div class="login-info-text-title">当前机构</div>
          <div>：</div>
          <div class="login-info-text-value">
            {{ enterpriseName }}
          </div>
        </div>
        <div class="login-info-text">
          <div class="login-info-text-title">登录用户</div>
          <div>：</div>
          <div class="login-info-text-value">{{ userName }}</div>
        </div>
        <div class="login-info-text">
          <div class="login-info-text-title">手机号</div>
          <div>：</div>
          <div class="login-info-text-value">{{ userPhone }}</div>
        </div>
        <div class="login-info-text">
          <div class="login-info-text-title">岗位</div>
          <div>：</div>
          <div class="login-info-text-value">{{ userStationStr }}</div>
        </div>
      </div>
      <div class="login-info-button-box">
        <div
          :class="[
            'customize-button',
            { primary: btnType == 1, info: btnType == 0 },
          ]"
          style="width: 100%"
          @click="handleLogin"
        >
          {{ btnText }}
        </div>
        <!-- <div
          class="customize-button plain"
          style="width: 100%; margin-top: 12px"
          @click="fetchData"
        >
          取消登录
        </div> -->
        <!-- @click="handlePurchase" -->
        <div class="login-info-button" @click="handlePurchase">
          <span>购买正式版</span>
          <i class="el-icon-d-arrow-right" />
        </div>
        <!-- <div class="login-info-button" style="font-size: 12px">
          <span>支付遇到问题，请联系客服</span>
          <i class="el-icon-d-arrow-right"></i>
        </div> -->
      </div>
    </div>

    <!-- <div class="login-footer">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="__blank">
        药事服务-V1.3beta
      </a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="__blank">
        黑ICP备2023002593号-2
      </a>
      <div>增值电信业务经言许可证编号:黑B2-20230613</div>
      <div>互联网药品信息服务资格证书编号:(黑)-经营性-2023-0116</div>
      <a
        href="https://xyt.xcc.cn/getpcInfo?sn=2003050568091631616&language=CN&certType=8&url=www.yaobailian.com"
        target="__blank"
      >
        <img class="login-footer-img" src="@/assets/login/ssl.png" alt="" />
      </a>
    </div> -->

    <Purchase ref="PurchaseRef" @successPay="handleLogin" />
  </div>
</template>

<script>
import Purchase from "@/components/Purchase";
import { getToken as getAuthToken } from "@/utils/auth";
export default {
  name: "Login",
  components: { Purchase },
  data() {
    return {
      codeUrl: "",
      isScanCode: false,
      isExpired: false,
      timer: null,
      enterpriseName: "",
      userName: "",
      userPhone: "",
      userStationStr: "",
      btnText: "",
      btnType: 0,
      icon: "",
      enterpriseId: "",
      openId: "",
      loading: false,
      loginLoading: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {},
  methods: {
    async handleLoginTest(type) {
      this.loginLoading = true;
      let param = {};
      // 连锁总部
      if (type == 1) {
        param = {
          enterpriseId: "6533d985-dfaa-4ad3-b755-38cbcd0a6884",
          openId: "oB7_K65nrFCJ9XItPtGzDVZQRYNw",
        };
      }
      // 连锁门店
      if (type == 0) {
        param = {
          enterpriseId: "50c075f2-6850-46ff-8729-f1144c26c2c8",
          openId: "oB7_K6xSo_-PP5BOrlTtpqXoAk-U",
        };
      }
      const res = await this.$api.enterprise.TruelyLogin(param);

      this.loginLoading = false;
      clearInterval(this.timer);
      this.$store
        .dispatch("user/login", res.data)
        .then(() => {
          this.$router.push({
            path: "/",
          });
        })
        .catch(() => {});
    },
    async handleLogin() {
      if (this.btnType === 0) return;
      this.loginLoading = true;
      const res = await this.$api.enterprise.TruelyLogin({
        enterpriseId: this.enterpriseId,
        openId: this.openId,
      });
      this.loginLoading = false;
      clearInterval(this.timer);
      this.$store
        .dispatch("user/login", res.data)
        .then(() => {
          this.$router.push({
            path: "/",
            // path: this.redirect || "/",
            // query: this.otherQuery,
          });
        })
        .catch(() => {});
    },
    async fetchData() {
      clearInterval(this.timer);
      this.isExpired = false;
      this.isScanCode = false;
      this.loading = true;
      const res = await this.$api.support.CreateScanQRCode();
      this.loading = false;
      this.codeUrl = res.data.qrCodeImg;
      setTimeout(() => {
        this.isExpired = true;
        clearInterval(this.timer);
      }, 120000);
      this.timer = setInterval(async () => {
        const beatRes = await this.$api.enterprise.HeartBeatLogin({
          loginKey: res.data.loginKey,
        });
        if (beatRes.data.success) {
          clearInterval(this.timer);
          if (!beatRes.data.jumpToLogin) {
            // 体验版
            this.enterpriseName = beatRes.data.enterpriseName;
            this.userName = beatRes.data.userName;
            this.userPhone = beatRes.data.userPhone;
            this.userStationStr = beatRes.data.userStationStr;
            this.btnText = beatRes.data.btnText;
            this.btnType = beatRes.data.btnType;
            this.icon = beatRes.data.icon;
            this.enterpriseId = beatRes.data.enterpriseId;
            this.openId = beatRes.data.openId;
            this.isScanCode = true;
          } else {
            // 正式版
            const TruelyRes = await this.$api.enterprise.TruelyLogin({
              enterpriseId: beatRes.data.enterpriseId,
              openId: beatRes.data.openId,
            });
            this.$store
              .dispatch("user/login", TruelyRes.data)
              .then(() => {
                this.$router.push({
                  path: "/",
                  // path: this.redirect || "/",
                  // query: this.otherQuery,
                });
              })
              .catch(() => {});
          }
        }
      }, 2000);
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    handlePurchase() {
      this.$refs.PurchaseRef.show(this.enterpriseId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
